export default __webpack_public_path__ + "static/media/clairvoyant.0f1bc885.jpg";